<template>
  <v-app>
    <v-toolbar app color="white">
      <v-toolbar-title class="grey--text">logo title</v-toolbar-title>
      <v-btn flat color="info" to="/post">主頁</v-btn>
      <v-btn flat color="info">賽馬</v-btn>
      <v-btn flat color="info">足球</v-btn>
      <v-btn flat color="info">股票</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="info">login</v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer app absolute color="info" ></v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'LayoutDefault',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
